<template>
  <div>
    <el-form ref="form" :model="formData" label-width="80px">
        <el-form-item label="审核人">
        <el-select ref="gw" v-model="formData.shr" placeholder="请选择" @change="selectGW">
          <el-option
                  v-for="(item,index) in options"
                  :key="item.i_id"
                  :label="item.vc_name"
                  :value="item.i_id"
          ></el-option>

        </el-select>
      </el-form-item>
      <el-form-item label="约束条件">
        <el-checkbox-group v-model="formData.shrtj">
          <el-checkbox label="gs" name="shrtj">公司</el-checkbox>
          <el-checkbox label="bm" name="shrtj">部门</el-checkbox>
          <el-checkbox label="cp" name="shrtj">产品</el-checkbox>
          <el-checkbox label="ck" name="shrtj">仓库</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="审核方式">
        <el-radio-group v-model="formData.shtype">
          <el-radio :label=1>并审</el-radio>
          <el-radio :label=0>或审</el-radio>
        </el-radio-group>
      </el-form-item>


     </el-form>
  </div>
</template>
<script>
import * as flowUtil from '@/utils/logicFlowJs.js';
export default {
  name: '',
  props: {
    nodeData: Object,
    lf: Object || String,
  },
  watch: {
    formData: {
      handler(n, o) {
        const nodeData = this.$props.nodeData
        this.$props.lf.setProperties(nodeData.id, n);
        this.$props.lf.updateText(nodeData.id, n.text);
      },
      deep:true// 深度监听父组件传过来对象变化
    },
  },
  mounted() {
    const { properties, text } = this.$props.nodeData
    if (text && text.value)  this.$data.formData.text = text.value
    if (properties) {
      this.$data.formData = Object.assign({}, this.$data.formData, properties)
      this.loadGwzj();
    }


  },
  data() {
    return {
      formData: {
        name: '',
        shrtj:[],
        shr:'',
        shtype: 0,


      },
      options:[]
    }
  },
  methods: {
    selectGW(){
     this.$nextTick(()=>{
        let t=this.$refs.gw.selected.label;
        this.$data.formData.text=t;
       //console.log("loadFlowType", t);
      })
    },
    //load岗位职级
    async loadGwzj() {
      let _this=this;
      let param = {};
      let res = await flowUtil.getGwzj(param);
      if (res.code == 1) {
        this.options= res.data;
      } else {
        //console.log("error",res)
      }
    },
  }
}
</script>
<style scoped>
  .el-form-item{
    margin-bottom: 4px;
  }
</style>
